export const MAX_FILE_SIZE_IN_MB = 3;

export const MAX_FILES = 2;
